import React, { Component } from 'react';
import Parser from 'html-react-parser';

import TAOS from "./../Taos";
import { ArrowIcon } from './SVGIcons';

class App extends Component {
  static defaultProps = {

  }

  render() {

    const data = this.props?.data || {}
    const links = data?.links || []

    const catalog = data?.katalog_ng || []

    return (
      <div className='mt-[80px] xl:mt-[100px]'>
        <div className='container'>
          <div className='flex flex-col xl:flex-row items-end justify-between leading-none gap-[20px]'>
            <div>
              <div className='uppercase tracking-tight text-title text-ptblack'>Каталог <span className='text-ptgray'>продукции</span></div>
              <div className='text-base text-ptgray mt-[12px]'>Разделили ассортимент по задачам закупки — так проще выбрать и согласовать поставку.</div>
            </div>
            <a href={links?.catalog} className='cursor-pointer w-full xl:w-auto bg-[#F6F7F8] duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
              <div className='text-base'>Вся продукция</div>
              <ArrowIcon />
            </a>
          </div>
          <div className='mt-[40px] flex xl:grid grid-cols-3 gap-[21px] overflow-x-auto overflow-y-hidden pb-[10px] xl:pb-[0px]'>
            {catalog.map((el, k) => (
              <div key={k} className="group w-[265px] xl:w-auto flex-none">
                <div
                  className='w-full rounded-[14px] overflow-hidden bg-center bg-cover bg-no-repeat relative'
                  style={{ backgroundImage: `url('${el.image}')` }}
                >
                  {/* Градиентный слой - появляется только при наведении */}
                  <div className='absolute inset-0 bg-gradient-to-t from-[#001351]/20 to-[#00071E] transition-all duration-300 opacity-0 group-hover:opacity-100'></div>
                  
                  {/* Контент всегда виден */}
                  <div className='relative z-10 w-full h-[260px] flex flex-col items-center justify-between p-[20px]'>
                    
                    {/* Текст - появляется при наведении */}
                    <div className='text-white font-light leading-none text-base w-full transition-all duration-300 opacity-0 group-hover:opacity-100'>
                      <div className='max-w-[253px]'>
                        {el.text}
                      </div>
                    </div>
                    
                    <a href={el.href} className='w-full flex justify-end'>
                      {/* Белый контейнер с меняющейся шириной - всегда виден */}
                      <div className='cursor-pointer bg-white ease-in-out hover:bg-[#DBE7F3] h-[38px] flex items-center justify-end rounded-[14px] transition-all duration-300 overflow-hidden w-[38px] group-hover:w-[162px]'>
                        
                        {/* Внутренний блок с фиксированной шириной */}
                        <div className='flex items-center gap-[12px] px-[12px] w-[162px]'>
                          
                          {/* Текст появляется при наведении */}
                          <div className='text-base whitespace-nowrap transition-all duration-300 opacity-0 group-hover:opacity-100'>
                            Перейти в каталог
                          </div>
                          
                          {/* Стрелка всегда видна */}
                          <ArrowIcon width={16} height={16} className="flex-shrink-0" />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div className='uppercase leading-none mt-[20px] text-cardTitle text-ptblack'>{el.title}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default App;
